import qs from 'qs';
import axiosClient from './axiosClient';
import { serviceBase } from './serviceBase';

export const getRentResume = serviceBase({
         request: options =>
           axiosClient.get('/accounting/account-statement', {
             params: options,
             paramsSerializer: params => {
               return qs.stringify(params, { arrayFormat: 'repeat' });
             }
           }),
         retry: 0
       });

export const downloadExportedRentResume = serviceBase({
         request: options =>
           axiosClient.get('/accounting/account-statement/export', {
             responseType: 'blob',
             params: options,
             timeout: 120000
           }),
         transformResponse: res => {
           try {
             const filename = 'RentaResumen.xlsx';
             const a = document.createElement('a');
             a.href = window.URL.createObjectURL(res.data);
             a.download = filename;
             a.style.display = 'none';
             document.body.appendChild(a);
             a.click();
           } catch (error) {
             console.log(`Opps, un error: ${error}`);
             console.error(error);
           }
         },
         retry: 0
       });
